var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-eye.e2689bf1.png","uri@2x": __webpack_public_path__ + "icon-eye.f0753af4.png","uri@3x": __webpack_public_path__ + "icon-eye.0d51a11a.png",
    width: 61,
    height: 55
});